import React,{useEffect,useState} from 'react'
import {salesByProd,salesByProdBySeller, updateColor} from 'network/ApiAxiosTickets'
import { Card, CardHeader, CardBody, Row, Col, CardImg, Table, Spinner,Modal,ModalHeader,ModalFooter,ModalBody, Input,Button} from "reactstrap";
import { ticketType } from 'network/ApiAxiosCeleApp';
import { eventByDateReport } from 'network/ApiAxiosReportsGetickets';
import axios from 'axios';

function NewEventReportSalesCard(props) {
    const [tableContent, setTableContent] = useState('');
    const [modal, setModal] = useState(false);
    const [modalStock, setModalStock] = useState(false);
    const [selectedTicket, setSelectedTicket] = useState('');
    const [colorInput, setColorInput] = useState('');
    const [stockInput, setStockInput] = useState('');

    const toggle = () => setModal(!modal);
    const toggleStock = () => setModalStock(!modalStock);

    useEffect(() => {
        props.event.eventDates.map((eventDate) => (
            getEvent(eventDate._id,eventDate.timeStart)
        ))
    }, []);

    const handleColor = async(ticketID)=>{
        const resp = await axios.post('https://new.geticketsonline.com:9876/event/color/update', {ticketId: selectedTicket, color: colorInput})
        if(resp.data.success){
            toggle()
        }else{
            alert('Error updating color')
        }
    }

    const handleStock = async(ticketID)=>{
        const resp = await axios.post('https://new.geticketsonline.com:9876/event/stock/update', {ticketId: selectedTicket, stock: stockInput})
        if(resp.data.success){
            toggleStock()
        }else{
            alert('Error updating color')
        }
    }

    const getEvent = async(eventDateId,timeStart)=>{
       const resp = await eventByDateReport(eventDateId)
         if(resp.data.success){
                setTableContent(oldArray =>
                    [...oldArray,
                        <Row key={eventDateId}>
                            <h3>{timeStart.split('T')[0]}</h3>
                            <Table className="align-items-center table-flush" key={eventDateId} responsive>
                                <thead className="thead-light">
                                    <tr>
                                    <th scope="col">Ticket</th>
                                    <th scope="col">Sold Online</th>
                                    <th scope="col">Sold Seller</th>
                                    <th scope="col">Sold Reseller</th>
                                    <th scope="col">Left</th>
                                    </tr>
                                </thead>
                                <tbody>
                                {resp.data.finalResult.map((ticketResult)=>{
                                            return(
                                                <tr key={ticketResult._id}>
                                                        <td onClick={()=> {setSelectedTicket(ticketResult._id);toggle()}}>{ticketResult.name}<span className='ml-3' style={{backgroundColor:ticketResult.color, width:'20px',minWidth:'20px', height:'20px'}}>{ticketResult.color && '-----'}</span></td>
                                                        <td>{ticketResult.sold}</td>
                                                        {console.log(resp.data.celeSales.finalResultSeller.find((saleItem)=>saleItem._id == ticketResult._id))}
                                                        <td>{resp.data.celeSales.finalResultSeller.find((saleItem)=>saleItem._id == ticketResult._id).sold}</td>
                                                        <td>{resp.data.celeSales.finalResultReseller.find((saleItem)=>saleItem._id == ticketResult._id).sold}</td>
                                                        <td onClick={()=> {setSelectedTicket(ticketResult._id);setStockInput(ticketResult.stock);toggleStock()}}>{ticketResult.stock}</td>
                                                </tr>
                                            )
                                            
                                        })}
                                </tbody>
                            </Table>
                        </Row>
                    ]
                )
         }
        
    }


  return (
    <Col className="mb-2" xl="6">
        <Card className="shadow">
            <CardHeader className="border-0 text-center">
                <Row className="text-center">
                    <Col>
                        <h3 className="mt-6">{props.event.name} </h3>
                    </Col>
                    <Col>
                        <CardImg style={{borderRadius: "150px"}} alt="Card image cap" src={"https://new.geticketsonline.com:9876/files/product-images/" + props.event.posterImage} top width="3%" />
                    </Col>
                </Row>
            </CardHeader>
            <CardBody>
                {/*data here*/}
                {/*
                    props.event.eventDates.map((eventDate)=>{
                        return getEvent(eventDate._id)
                    })
                
                <Row>
                    {props.event.eventDates.map((eventDate) => (
                        <Col key={eventDate._id} className="mb-4">
                            <h5 className="text-center">Something</h5>
                            {getEvent(eventDate._id)}
                        </Col>
                    ))}
                </Row>
                */}
                {
                    tableContent && tableContent
                }
                <Row className=' justify-content-center'>
                    {!tableContent && <Spinner color="primary" style={{height: '3rem',width: '3rem'}}>.</Spinner>}
                </Row>
            </CardBody>
        </Card>
        <Modal isOpen={modal} toggle={toggle} className="modal-dialog-centered">
            <ModalHeader toggle={toggle}>Bracelet Color</ModalHeader>
            <ModalBody>
                <Input type="text" onChange={(e)=>setColorInput(e.target.value)} value={colorInput} />
            </ModalBody>
            <ModalFooter>
                <Button color="secondary" onClick={()=>handleColor()}>Save</Button>
                <Button color="secondary" onClick={()=>toggle()}>Close</Button>
            </ModalFooter>
        </Modal>
        <Modal isOpen={modalStock} toggle={toggleStock} className="modal-dialog-centered">
            <ModalHeader toggle={toggleStock}>Ticket Stock</ModalHeader>
            <ModalBody>
                <Input type="number" onChange={(e)=>setStockInput(e.target.value)} value={stockInput} />
            </ModalBody>
            <ModalFooter>
                <Button color="secondary" onClick={()=>handleStock()}>Save</Button>
                <Button color="secondary" onClick={()=>toggleStock()}>Close</Button>
            </ModalFooter>
        </Modal>
    </Col>
  )
}

export default NewEventReportSalesCard